
define(function(){
	var IpsModelCollection = require('civicsBase/ipsModelCollection');
	const builder = require('civicsUtils/buildUrlParameters');
	const AvailableFeatures = require('civicsUtils/available_features');

	return IpsModelCollection.extend({
		url: function() {
			if(AvailableFeatures.TypeFilterStoredProcedure() && this.isInMyProjectCardView){
				return '/delegate/civics-api/api/portal/myinstrumenttypes';
			}else{
				let urlRoot = '/delegate/civics-api/api/core/views/instrumentsubtypes';
				var parameters = '';
				if (this.urlParameters != undefined) {
					parameters = builder.buildUrlParameters(this.urlParameters)
				}
				if (parameters.indexOf('?') >= 0) {
					parameters += '&Page=[{Max:0}]';
				} else {
					parameters += '?Page=[{Max:0}]';
				}
				return urlRoot + parameters;
			}
		},
    parse: function(response) {
			var data = response.data ? response.data : [];
			var values = [];
			for (var i = 0; i < data.length; i++) {
				if (((AvailableFeatures.TypeFilterStoredProcedure() && this.isInMyProjectCardView) || data[i].showInPortal) && data[i].typeKey != 1) {
					var obj = {};
					obj.value = data[i].typeCode ? data[i].typeCode : data[i].instrumentType;
					obj.displayName = Handlebars.helpers['global:computedDescription'](data[i].portalDescription, data[i].typeDescription); // or portal description
					obj.displayName = obj.displayName && obj.displayName.trim() != '' ? obj.displayName : obj.value;
					obj.propertyName = 'instrumentSubType';
					obj.submitInPortal = data[i].submitInPortal ? data[i].submitInPortal.toLowerCase() === 'y' : false;
					obj.instrumentType = data[i].instrumentType;

					if(AvailableFeatures.SubtypeFilterParam()){
						obj.extendedAttributes = [{instrumentTypeID: data[i].instrumentTypeID}];
					}
					else{
						obj.extendedAttributes = [{instrumentType: data[i].instrumentType}];
					}
					values.push(obj);
				}
			};
			//make the type list unquie based on the display name
			values = _.uniq(values, function (e) {
				return e.displayName;
			});

			values.sort(function (a, b) {
				return a.displayName.localeCompare(b.displayName, undefined, { numeric: true, sensitivity: 'base' });
			});

			return values;
		}
  });

});
